import { render, staticRenderFns } from "./activaMerchant.vue?vue&type=template&id=5795307e&scoped=true"
import script from "./activaMerchant.vue?vue&type=script&lang=js"
export * from "./activaMerchant.vue?vue&type=script&lang=js"
import style0 from "./activaMerchant.vue?vue&type=style&index=0&id=5795307e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795307e",
  null
  
)

export default component.exports